import React from 'react';
import { Switch, Route } from 'react-router-dom';

import AddUser from './Add';
import EditUser from './Edit'
import ViewUser from './View';
import ListUsers from './List'

import '../style.css'

export default function ManageUsers() {
  return <Switch>
    <Route path="/account/users/add" component={AddUser} />
    <Route path="/account/users/edit" component={EditUser} />
    <Route path="/account/users/:id" component={ViewUser} />
    <Route path="/account/users" component={ListUsers} />
  </Switch>
}